import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateField = (name, value) => {
    let error = "";

    if (name === "name") {
      if (!value.trim()) error = "Full Name is required";
    }

    if (name === "email") {
      if (!value.trim()) {
        error = "Email is required";
      } else if (!/^\S+@\S+\.\S+$/.test(value)) {
        error = "Invalid email format";
      }
    }

    if (name === "mobile") {
      if (!value.trim()) {
        error = "Mobile number is required";
      }
    }

    if (name === "message") {
      if (!value.trim()) error = "Message is required";
    }

    return error;
  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    const error = validateField(name, value);

    setErrors({
      ...errors,
      [name]: error
    });
  };

  const validateForm = () => {

    let newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    return newErrors;
  };

 const handleSubmit = async (e) => {

    e.preventDefault();

    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {

      try {

        setLoading(true);

        const response = await fetch("https://clearandclean.co.nz/clean-server/public/send", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (response.ok) {

          setSuccess(true);

          setFormData({
            name: "",
            email: "",
            mobile: "",
            subject: "",
            message: ""
          });

        } else {
          alert(result.message || "Something went wrong");
        }

      } catch (error) {
        console.error(error);
        alert("Server error. Please try again.");
      }

      setLoading(false);
    }
  };

  return (
    <div>
 {loading && (
      <div className="page-loader">
        <div className="loader-spinner"></div>
      </div>
    )}
       <Helmet>
        <title>Contact Clear &amp; Clean | Commercial Cleaning Christchurch</title>
        <meta
          name="description"
          content="Contact Clear & Clean for a free quote on commercial cleaning services in Christchurch and Canterbury. Call +64 22 086 6040 or email info@clearandclean.co.nz."
        />
        <meta
          name="keywords"
          content="contact Clear and Clean, commercial cleaning quote Christchurch, cleaning services Canterbury, cleaning company contact NZ"
        />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/contact" />
        <meta property="og:title" content="Contact Clear & Clean | Commercial Cleaning Christchurch" />
        <meta
          property="og:description"
          content="Get a free quote for professional commercial cleaning in Christchurch and Canterbury. Contact our team today."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.clearandclean.co.nz/contact" />
        <meta property="og:image" content="https://www.clearandclean.co.nz/images/contact_banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Clear & Clean | Commercial Cleaning Christchurch" />
        <meta
          name="twitter:description"
          content="Get a free quote for professional commercial cleaning in Christchurch and Canterbury."
        />
        {/* BreadcrumbList */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",    "item": "https://www.clearandclean.co.nz/" },
              { "@type": "ListItem", "position": 2, "name": "Contact", "item": "https://www.clearandclean.co.nz/contact" }
            ]
          }
        `}</script>

        {/* LocalBusiness structured data for Google */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Clear & Clean",
            "description": "Professional commercial cleaning services in Christchurch and Canterbury, New Zealand.",
            "url": "https://www.clearandclean.co.nz",
            "telephone": "+64220866040",
            "email": "info@clearandclean.co.nz",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "23 Conailles Street, Halswell",
              "addressLocality": "Christchurch",
              "addressRegion": "Canterbury",
              "addressCountry": "NZ"
            },
            "areaServed": {
              "@type": "Place",
              "name": "Christchurch, Canterbury, New Zealand"
            },
            "openingHours": "Mo-Fr 08:00-17:00"
          }
        `}</script>
      </Helmet>

      <section className="hero-wrap hero-wrap-2" style={{backgroundImage: 'url("images/contact_banner.jpg")'}} data-stellar-background-ratio="0.5">
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9 ftco-animate pb-5">
              <p className="breadcrumbs mb-2">
                <span className="mr-2">
                  <Link to="/">
                    Home <i className="fa fa-chevron-right" />
                  </Link>
                </span>
                <span>Contact <i className="fa fa-chevron-right" /></span>
              </p>
              <h1 className="mb-0 bread">Contact</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="ftco-section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="wrapper">


<div class="row mb-5">
								<div class="col-md-3">
									<div class="dbox w-100 text-center">
				        		<div class="icon d-flex align-items-center justify-content-center">
				        			<span class="fa fa-map-marker"></span>
				        		</div>
				        		<div class="text">
					            <p><span>Address:</span> 23 Conailles Street, Halswell, Christchurch</p>
					          </div>
				          </div>
								</div>
								<div class="col-md-3">
									<div class="dbox w-100 text-center">
				        		<div class="icon d-flex align-items-center justify-content-center">
				        			<span class="fa fa-phone"></span>
				        		</div>
				        		<div class="text">
					            <p><span>Phone:</span> <a href="tel://+64220866040">+64 22 086 6040</a></p>
					          </div>
				          </div>
								</div>
								<div class="col-md-3">
									<div class="dbox w-100 text-center">
				        		<div class="icon d-flex align-items-center justify-content-center">
				        			<span class="fa fa-paper-plane"></span>
				        		</div>
				        		<div class="text">
					            <p><span>Email:</span><a href="mailto:info@clearandclean.co.nz"> info@clearandclean.co.nz</a>
</p>
					          </div>
				          </div>
								</div>
								<div class="col-md-3">
									<div class="dbox w-100 text-center">
				        		<div class="icon d-flex align-items-center justify-content-center">
				        			<span class="fa fa-globe"></span>
				        		</div>
				        		<div class="text">
					            <p><span>Website</span> <a href="https://www.clearandclean.co.nz" target="_blank" rel="noopener noreferrer">
            www.clearandclean.co.nz
          </a></p>
					          </div>
				          </div>
								</div>
							</div>

                <div className="row no-gutters">

                  <div className="col-md-7">
                    <div className="contact-wrap w-100 p-md-5 p-4">
                      <h3 className="mb-4">Contact Us</h3>

                      {success && (
                        <div className="alert alert-success">
                          Your message was sent, thank you!
                        </div>
                      )}

                      <form id="contactForm" name="contactForm" className="contactForm" onSubmit={handleSubmit}>
                        <div className="row">

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="label">Full Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                              />
                              {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="label">Email Address</label>
                              <input
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                              />
                              {errors.email && <small className="text-danger">{errors.email}</small>}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="label">Mobile Number</label>
                              <input
                                type="text"
                                className="form-control"
                                name="mobile"
                                placeholder="Mobile Number"
                                value={formData.mobile}
                                onChange={handleChange}
                              />
                              {errors.mobile && <small className="text-danger">{errors.mobile}</small>}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="label">Subject</label>
                              <input
                                type="text"
                                className="form-control"
                                name="subject"
                                placeholder="Subject"
                                value={formData.subject}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="label">Message</label>
                              <textarea
                                name="message"
                                className="form-control"
                                cols={30}
                                rows={4}
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleChange}
                              />
                              {errors.message && <small className="text-danger">{errors.message}</small>}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="submit"
                                value="Send Message"
                                className="btn btn-primary"
                              />
                              <div className="submitting" />
                            </div>
                          </div>

                        </div>
                      </form>

                    </div>
                  </div>

                  <div className="col-md-5 d-flex align-items-stretch">
                    <div className="info-wrap w-100 p-5 img" style={{backgroundImage: 'url(images/about.jpg)'}}></div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Contact;